<template>
  <div :class="$style.box" @touchmove.prevent>
    <div :class="$style.content">
      <img :src="`${$cdnUrl}/dragonCity/sign_bg.png`" />
      <img :src="`${$cdnUrl}/dragonCity/close.png`" @click="close" />
      <div :class="$style.enter" @click="jump"></div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    const date = new Date();
    localStorage.setItem('lottery-date', date);
  },
  methods: {
    jump() {
      this.$router.push({ name: 'activity.dragonCity' });
      this.$emit('close');
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" module>
.box {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 300;
  .content {
    width: 100%;
    min-height: 386px;
    margin: 60px auto;
    position: relative;

    > img:nth-child(1) {
      width: 100%;
    }
    > img:nth-child(2) {
      width: 30px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 14px;
    }
    .enter {
      width: 150px;
      height: 40px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 96px;
    }
  }
}
</style>